export const environment = {
    production: true,

    //EndPoints APIs Servicios QA
    url_auth: 'https://him1nvkp6e.execute-api.us-east-1.amazonaws.com/api/Auth/login',
    url_seguridad: 'https://him1nvkp6e.execute-api.us-east-1.amazonaws.com/api',
    url_negocio_proveedores: 'https://ia6tjb3fxg.execute-api.us-east-1.amazonaws.com/api/v1/negocio_proveedores',

    url_negocio_documentos: 'https://hweyl35edl.execute-api.us-east-1.amazonaws.com/Prod/api/v1/negocio_documentos',
    url_carga_factura_cf: 'https://hweyl35edl.execute-api.us-east-1.amazonaws.com/Prod/api',
    url_carga_factura: 'https://hweyl35edl.execute-api.us-east-1.amazonaws.com/Prod/api',
    
    // url_negocio_documentos: 'https://localhost:5001/api/v1/negocio_documentos',
    // url_carga_factura_cf: 'https://localhost:5001/api',
    // url_carga_factura: 'https://localhost:5001/api',

    url_gestion: 'https://ighuxf4nrl.execute-api.us-east-1.amazonaws.com/api',
    url_repse_proveedor: 'https://l4zzz2mkk5.execute-api.us-east-1.amazonaws.com/Prod/api',
};